/**
 * Add your logic when cart started, added or completed
 */

// klaviyo _learnq analytics
var _learnq = window._learnq || [];

$(document).ready(function () {
  // Intercept when cart requests start
  $(document).on('cart.requestStarted', function (event, request) {
    if (request.type === 'add') {
      // console.log('Adding item to cart:', request.data);
    }
  });

  // Intercept when cart requests complete successfully
  $(document).on('cart.requestComplete', function (event, cart) {
    // klaviyo analytics
    _learnq.push(['track', 'Added to Cart', cart]);

    // Get the most recently added item (last item in the items array)
    // const latestItem = cart.items[cart.items.length - 1];

    // Log detailed information about the latest item
    /**
    console.log('Latest added item:', {
      title: latestItem.title,
      variant_id: latestItem.variant_id,
      quantity: latestItem.quantity,
      price: latestItem.price,
      line_price: latestItem.line_price,
      sku: latestItem.sku,
      properties: latestItem.properties,
    });

    // Log cart totals
    console.log('Cart totals:', {
      total_items: cart.item_count,
      total_price: cart.total_price,
      total_weight: cart.total_weight,
    });**/
  });

  // Intercept any errors
  $(document).on('cart.requestError', function (event, response) {
    console.error('Cart error occurred:', response);
  });

  // Intercept in PDP
  // Intercept clicks on add to cart buttons
  $(
    'form[action="/cart/add"] button[type="submit"], button.add-to-cart, input[type="submit"].add-to-cart'
  ).on('click', function (e) {
    // Optional: Track the cart state after addition
    setTimeout(function () {
      $.getJSON('/cart.js', function (cart) {
        // klaviyo analytics
        _learnq.push(['track', 'Added to Cart', cart]);
      });
    }, 500); // Small delay to ensure cart is updated
  });
});
